import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { messages as enMessages } from '../i18n/translations/en';
import { messages as nlMessages } from '../i18n/translations/nl';

// Define the page keys that match the keys in the translations
export type PageKey = 
  | 'home' 
  | 'features' 
  | 'pricing' 
  | 'contact' 
  | 'faq' 
  | 'termsOfService' 
  | 'privacyPolicy'
  | 'invoiceStatus';

interface SEOHeadProps {
  pageKey: PageKey;
}

export const SEOHead: React.FC<SEOHeadProps> = ({ pageKey }) => {
  const { language } = useLanguage();
  
  // Get the appropriate messages based on the current language
  const messages = language === 'nl' ? nlMessages : enMessages;
  
  // Get the SEO data for the current page, or use defaults if not found
  const title = messages.seo[pageKey]?.title || messages.seo.defaultTitle;
  const description = messages.seo[pageKey]?.description || messages.seo.defaultDescription;
  
  // Create the SEO data object
  const seoData = {
    title,
    description,
    language,
    pageKey
  };
  
  // Convert the SEO data to a JSON string
  const seoJson = JSON.stringify(seoData);
  
  // Return a script tag with the SEO data as JSON
  // The data-seo-metadata attribute makes it easy to find during post-processing
  return (
    <script 
      type="application/json" 
      data-seo-metadata="true" 
      dangerouslySetInnerHTML={{ __html: seoJson }} 
    />
  );
}; 